import { ENVIRONMENT } from '@env/environment';
import { isSessionFeatureDisabled } from './session-feature-utils';

/**
 * Parse ENABLED_PAGES from environment configuration
 * Handles both string (comma-separated) and array formats
 * Filters out pages that are explicitly disabled in session storage
 * @returns Array of enabled page names
 */
export function getEnabledPages(): string[] {
  const envPages = Array.isArray(ENVIRONMENT.ENABLED_PAGES)
    ? ENVIRONMENT.ENABLED_PAGES
    : ENVIRONMENT.ENABLED_PAGES?.split(',').map((p: string) => p.trim()) || [];

  // Filter out pages that are explicitly disabled in session storage
  return envPages.filter(page => !isSessionFeatureDisabled(page));
}

/**
 * Check if a specific page is enabled in the environment configuration
 * @param pageName - The name of the page to check (e.g., 'users', 'tariffs')
 * @returns True if the page is enabled, false otherwise
 */
export function isPageEnabled(pageName: string): boolean {
  return getEnabledPages().includes(pageName);
}
